<!--
 - Author : 003.
 - Date   : 2019/6/3.
 - File   : popover.第一食堂弹窗
 -->

<template>
  <div class="popup-wrap" :style="{width: width}">
    <span class="popup-wrap-close" @click="close()">
      <i class="iconfont icon-guanbi"></i>
    </span>
    <div class="popup-wrap-title" v-if="title">{{title}}</div>
    <div class="popup-wrap-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Popover',
  data () {
    return {
    }
  },
  props: ['title', 'width'],
  methods: {
    /**
     * 关闭事件
     * @author: whl
     * @createDate: 2019/6/4
     * @return {Object}
     */
    close () {
      this.$emit('closeEvent')
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less">
  @import '../assets/less/color';
  .popup-wrap{
    position: relative;
    border-radius: 10px;
    background: rgba(0, 48, 84, .9);
    border: 1px solid #0090ff;
    box-shadow: 0px 6px 0px 0px rgba(0, 0, 0, .3);
    z-index: 5;
    width: 703px;
    text-align: left;
    min-width: 300px;
    &-close{
      position: absolute;
      top: 10px;
      right: 15px;
      color: @lightBlue;
      cursor: pointer;
      i{
        font-size: 22px;
      }
    }
    &-close:hover{
      opacity: 0.8;
    }
    &-title{
      margin: 2px;
      padding: 10px 20px;
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      text-align: left;
      border-radius: 10px;
      /*background: #016cb7;*/
      background: -webkit-linear-gradient(#016cb7, #023b63); /* Safari 5.1 - 6.0 */
      background: -o-linear-gradient(#016cb7, #023b63); /* Opera 11.1 - 12.0 */
      background: -moz-linear-gradient(#016cb7, #023b63); /* Firefox 3.6 - 15 */
      background: linear-gradient(#016cb7, #023b63); /* 标准的语法 */
    }
    &-content{
      padding: 10px 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Popover.vue